module.exports = __webpack_public_path__ + "static/media/  (126).2ec0e6a8.jpg";